import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import config from "appConfig";
import { LessonView, MobilePlaceholder, AudioSpinner, LessonCourseOverviewModal } from "@jelly/lesson";
import useCourseController from "../controllers/useCourseController";

import defaultStyle from "./Course.module.scss";
import Layout from "../components/Layout/Layout";

interface CoursePageParams {
  lessonId?: string;
  courseId: string;
}

const CoursePage: React.FC = () => {
  const mobileThreshold = config.MOBILE_THRESHOLD ?? 1012;

  const { lessonId, courseId } = useParams<CoursePageParams>();
  const [visibleOverview, setVisibleOverview] = useState(false);

  // Close modal if lesson has changed
  useEffect(() => {
    setVisibleOverview(false);
  }, [lessonId]);

  const {
    course,
    lesson,
    relatedLessons,
    chapters,
    tasks,
    courseLessonsProgress,
    onCheckTaskAnswer,
    onLessonComplete,
    onTaskComplete,
  } = useCourseController(courseId, lessonId);

  useEffect(() => {
    if (lesson && course) {
      document.title = `ASKNow - Lesson ${course.publicId}.${lesson.publicId}`;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [course?.publicId, lesson?.publicId]);

  return (
    <div className={defaultStyle.root}>
      {/*
      To render LessonView here we use `key` prop to preventing incorrect state in this component when lesson change

      See: https://stackoverflow.com/questions/63790530/preventing-of-incorrect-state-with-react-hooks
      */}
      <MobilePlaceholder triggerWidth={mobileThreshold}>
        <Layout headerText={`${course?.publicId}. ${course?.name}`} onHeaderClick={() => setVisibleOverview(true)}>
          <LessonView
            lessonId={lesson?.id}
            coursePublicId={course?.publicId}
            lessonPublicId={lesson?.publicId}
            name={lesson?.name}
            relatedLessons={relatedLessons}
            slides={lesson?.body}
            chapters={chapters}
            tasks={tasks}
            onCheckTaskAnswer={onCheckTaskAnswer}
            onLessonComplete={onLessonComplete}
            onTaskComplete={onTaskComplete}
            onClickTableOfContentsDetails={() => setVisibleOverview(true)}
            showHeaderNavigation={lesson?.showHeaderNavigation}
            enableResizableTheory={true}
          />
          <LessonCourseOverviewModal
            course={{ id: courseId }}
            lessons={courseLessonsProgress}
            visible={visibleOverview}
            activeLesson={lessonId}
            closeIcon="cil-fullscreen-exit"
            onClose={() => setVisibleOverview(false)}
          >
            <div className={defaultStyle.modalOverviewHeader}>
              <h1>Course overview</h1>
              <p>{course?.shortDescription || ""}</p>
            </div>
          </LessonCourseOverviewModal>
        </Layout>
      </MobilePlaceholder>
      <AudioSpinner />
    </div>
  );
};

export default CoursePage;
